// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { GaContextCustomer } from "../schema";

export function serialize_GaContextCustomer_internal(value: GaContextCustomer): unknown {
  return ((value: { customerId: number }): unknown => {
    return {
      customerId: ((value: number): unknown => {
        return value;
      })(value["customerId"]),
    };
  })(value);
}
export function serialize_GaContextCustomer(obj: GaContextCustomer): string {
  return renderJsonWithNumbersAsBigint(serialize_GaContextCustomer_internal(obj));
}
export function deserialize_GaContextCustomer_internal(value: unknown): ParserResult<GaContextCustomer> {
  return ((
    value: unknown,
  ): ParserResult<{
    customerId: number;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/GaContextCustomer]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/GaContextCustomer]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "customerId")) {
      return { success: false, reason: `[#/components/schemas/GaContextCustomer/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
    }
    const parsed_customerId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/GaContextCustomer/customerId]: '${value}' expected to be of type number.` };
      })(value["customerId"]);
    })();
    if (!parsed_customerId.success) {
      return { success: false, reason: parsed_customerId.reason };
    }
    return { success: true, value: { customerId: parsed_customerId.value } };
  })(value);
}
export function deserialize_GaContextCustomer(str: string): ParserResult<GaContextCustomer> {
  return deserialize_GaContextCustomer_internal(parseJsonWithNumbersAsBigint(str));
}
